import React, { useState, useEffect } from 'react';
import { Container, Typography, Paper, Box, Grid, FormControl, InputLabel, Select, MenuItem, TextField, Tabs, Tab, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import StockIssueTable from '../../components/transaction/StockIssueTable';
import { useSelector, useDispatch } from 'react-redux';
import { fetchStockIssues, fetchUniqueEmployees, fetchUniqueBatches } from '../../redux/actions/stockIssue/stockIssueAction';

const StockReceivePage = () => {
  const dispatch = useDispatch();
  const { filteredStockIssues, loading } = useSelector((state) => state.stockIssue);
  const { user } = useSelector((state) => state.login);

  // Filters
  const [status, setStatus] = useState('issued');
  const [selectedEmployee, setSelectedEmployee] = useState('');
  const [selectedBatch, setSelectedBatch] = useState('');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    dispatch(fetchStockIssues({ limit: 0, today_only: false }));
    dispatch(fetchUniqueEmployees());
    dispatch(fetchUniqueBatches());
  }, [dispatch, refreshKey]);

  // Filter logic
  const filteredData = Array.isArray(filteredStockIssues) ? filteredStockIssues.filter(issue => {
    if (status && status !== 'all' && issue.status !== status) return false;
    if (selectedEmployee && issue.emp_code !== selectedEmployee) return false;
    if (selectedBatch && issue.batch_no !== selectedBatch) return false;
    if (fromDate && new Date(issue.created_at) < new Date(fromDate)) return false;
    if (toDate && new Date(issue.created_at) > new Date(toDate + 'T23:59:59')) return false;
    return true;
  }) : [];

  // Remove uniqueEmployees and uniqueBatches from Redux
  // Compute dropdown options from filteredStockIssues
  const employeeOptions = Array.isArray(filteredStockIssues)
    ? Array.from(new Set(filteredStockIssues.map(issue => issue.emp_code).filter(Boolean)))
    : [];
  const batchOptions = Array.isArray(filteredStockIssues)
    ? Array.from(new Set(filteredStockIssues.map(issue => issue.batch_no).filter(Boolean)))
    : [];

  const handleClearFilters = () => {
    setStatus('issued');
    setSelectedEmployee('');
    setSelectedBatch('');
    setFromDate('');
    setToDate('');
    setRefreshKey(k => k + 1);
  };

  return (
    <>
      <Box sx={{ mb: 2 }}>
        <Button
          component={Link}
          to="/activity-log"
          variant="contained"
          color="primary"
        >
          View Activity Log
        </Button>
      </Box>
      <Container component="main" maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
        <Paper elevation={3} sx={{ p: { xs: 2, md: 3 } }}>
          <Box sx={{ mb: 2 }}>
            <Typography variant="h5" component="h1" sx={{ fontWeight: 'bold' }}>
              Stock Receive
            </Typography>
          </Box>
          <Box sx={{ mb: 2 }}>
            <Grid container spacing={2} alignItems="center">
              <Grid item>
                <Tabs
                  value={status}
                  onChange={(e, newValue) => setStatus(newValue)}
                  indicatorColor="primary"
                  textColor="primary"
                  aria-label="pending-received-toggle"
                >
                  <Tab label="Pending" value="issued" />
                  <Tab label="Received" value="received" />
                  <Tab label="All" value="all" />
                </Tabs>
              </Grid>
              <Grid item>
                <FormControl sx={{ minWidth: 180 }} size="small">
                  <InputLabel>Employee</InputLabel>
                  <Select
                    value={selectedEmployee}
                    label="Employee"
                    onChange={e => setSelectedEmployee(e.target.value)}
                  >
                    <MenuItem value=""><em>All Employees</em></MenuItem>
                    {employeeOptions.map(emp_code => (
                      <MenuItem key={emp_code} value={emp_code}>
                        {emp_code}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item>
                <FormControl sx={{ minWidth: 150 }} size="small">
                  <InputLabel>Batch</InputLabel>
                  <Select
                    value={selectedBatch}
                    label="Batch"
                    onChange={e => setSelectedBatch(e.target.value)}
                  >
                    <MenuItem value=""><em>All Batches</em></MenuItem>
                    {batchOptions.map(batch_no => (
                      <MenuItem key={batch_no} value={batch_no}>
                        {batch_no}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item>
                <TextField
                  label="From Date"
                  type="date"
                  size="small"
                  value={fromDate}
                  onChange={e => setFromDate(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item>
                <TextField
                  label="To Date"
                  type="date"
                  size="small"
                  value={toDate}
                  onChange={e => setToDate(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item>
                <Button variant="outlined" color="secondary" onClick={handleClearFilters}>Clear Filters</Button>
              </Grid>
            </Grid>
          </Box>
          <StockIssueTable
            data={filteredData}
            loading={loading}
            currentUser={user}
            showReceiveIcon={true}
            onRefresh={() => setRefreshKey(k => k + 1)}
          />
        </Paper>
      </Container>
    </>
  );
};

export default StockReceivePage; 